import { categoriesService } from '../services';

export const categories = {
    namespaced: true,
    state: {
        all: {},
        selected: {},
        default: {}
    },
    actions: {
        getAll({ commit }, id) {
            commit('getAllRequest');

            return new Promise((resolve, reject) => {
                categoriesService.getAll(id)
                .then(
                    payload => {
                        commit('getAllSuccess', payload)
                        resolve(payload)
                    }, 
                    error => {
                        commit('getAllFailure', error)
                        reject(error)
                    } 
                )
            });
            
        },

        delete({
            commit
        }, dto) {
            commit('defaultRequest');

            return new Promise((resolve, reject) => {
                categoriesService.deleteExisting(dto)
                    .then(
                        payload => {
                            commit('defaultRequest', payload);
                            resolve(payload)
                        },
                        error => {
                            commit('defaultRequest', error);
                            reject(error)
                        }
                    );
            })
        },

        update({
            commit
        }, dto) {
            commit('defaultRequest');

            return new Promise((resolve, reject) => {
                categoriesService.updateExisting(dto)
                    .then(
                        payload => {
                            commit('defaultRequest', payload);
                            resolve(payload)
                        },
                        error => {
                            commit('defaultRequest', error);
                            reject(error)
                        }
                    );
            })
        },
        
        create({
            commit
        }, dto) {
            commit('defaultRequest');

            return new Promise((resolve, reject) => {
                categoriesService.createNew(dto)
                    .then(
                        payload => {
                            commit('defaultSuccess', payload);
                            resolve(payload)
                        },
                        error => {
                            commit('defaultFailure', error);
                            reject(error)
                        }
                    );
            })
        },
    },
    mutations: {

        defaultRequest(state) {
            state.default = {
                loading: true
            }; 
        },
        defaultSuccess(state, payload) {
            state.default = {
                item: payload,
                loading: false
            }; 
        },
        defaultFailure(state, error) {
            state.default = {
                error,
                loading: false
            }; 
        },

        getRequest(state) {
            state.selected = { loading: true };
        },
        getSuccess(state, user) {
            state.selected = { item: user };
        },
        getFailure(state, error) {
            state.selected = { error };
        },
        getAllRequest(state) {
            state.all = { loading: true };
        },
        getAllSuccess(state, payload) {
            state.all = { items: payload };
        },
        getAllFailure(state, error) {
            state.all = { error };
        }
    }
}